export default __webpack_public_path__ + "static/media/FR.4128d8d8.svg";